
export default {
  /**
   * 航跡管理追加
   *
   * @param state
   * @param payload
   * @constructor
   */
  CREATE: (state, payload) => {
    if(payload) {

      state.vessel = payload;
    }
  },
  /**
   * 全データクリア
   *
   * @param state
   * @constructor
   */
  CLEAR: (state) => {
    state.vessel = null
  }
}
